import smoothScroll from '../utils/smoothScroll';

const toProductsLink = document.getElementById('scroll-products');
const productsSection = document.getElementById('products');
const toProductFAQLink = document.getElementById('scroll-product-faq');
const productFAQSection = document.getElementById('product-faq');

// add some offset, so the element is visible when scrolled to
// (~ header height + spacer grand)
const addClickEvent = (link, section, offset = 220) => {
  // get element's position
  if (section) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      smoothScroll(section.offsetTop + window.screen.height - offset);
    });
  }
};

(() => {
  if (toProductsLink) {
    addClickEvent(toProductsLink, productsSection);
  }
  if (toProductFAQLink) {
    addClickEvent(toProductFAQLink, productFAQSection);
  }
})();
